import React from "react";
import Einladung from "assets/svgs/Einladung.svg";
import Friend from "assets/svgs/Friend.svg";
import Points from "assets/svgs/points.svg";
import * as styles from "./style.mod.scss";
import locale from "locales";

const Highlights = () => {
  const highlightsLoc = locale.inviteFriends.highlights;
  return (
    <div className={styles.highlights}>
      <div className={styles.highlightsItems}>
        <Einladung />
        <p className={styles.title}>{highlightsLoc.firstTitle}</p>
        <p className={styles.mobileTitle}>{highlightsLoc.mobFirstTitle}</p>
      </div>
      <div className={styles.highlightsItems}>
        <Friend />
        <p className={styles.title}>{highlightsLoc.secondTitle}</p>
        <p className={styles.mobileTitle}>{highlightsLoc.mobSecTtile}</p>
      </div>
      <div className={styles.highlightsItems}>
        <Points />
        <p className={styles.title}>{highlightsLoc.thirdTitle}</p>
        <p className={ styles.mobileTitle}>{highlightsLoc.mobThirdTtitle}</p>
      </div>
    </div>
  );
};

export default Highlights;